export default __webpack_public_path__ + "static/media/V380MANB5.0a844e6d.pdf";